import React, { useContext } from "react";
import { NavigationTabs } from "../../../../layouts/header/NavigationTabs";
import { Button } from "../../../../shadcn/components/ui/button";
import SearchIcon from "../../../../icons/SearchIcon";
import { Context, payloadToUrl } from "services";
import { SearchInput } from "../../../../shadcn/components/custom/search/SearchInput";
import { useRouter } from "next/router";
import CustomSearchDropdown from "../../../../shadcn/components/custom/dropdown/CustomSearchDropdown";

export default function SearchComponent(props: any) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);

  const handleSubmit = () => {
    payloadToUrl(router, searchForm.value);
  };

  return (
    <div className="drop-shadow-lg">
      <div className="bg-[#FF752C33] p-0.5 clip-path-searchMobilePolygon lg:clip-path-searchWebPolygon">
        <div className="bg-white flex min-h-[159px] lg:min-h-[183px] w-full z-12 clip-path-searchMobilePolygon lg:clip-path-searchWebPolygon">
          {/* Top part */}
          <div className="w-full mb-[56px] lg:mb-0 pl-3 pr-[10px] pt-3 lg:pl-[26px] lg:pt-[22px] lg:pr-0">
            <p className="font-openSans font-normal leading-6 text-brand-bgBlack text-web-subheading break-words ">
              Properties For Auction in{" "}
              <span className="capitalize pr-3">
                {searchForm.value?.city?.label}
              </span>
            </p>
            <NavigationTabs />
          </div>
        </div>
      </div>

      <div className="absolute -bottom-1 lg:bottom-0.5 w-full">
        {/* Search bar */}
        <div className="w-full pl-[3px] pb-[5px] lg:pr-[13px] lg:pl-3 lg:pb-[10px]">
          <SearchInput
            placeholder="Search for plots"
            prefix={
              <div className="w-[93px] md:w-[153px] md:pl-[18px]">
                {/* <Dropdown
                  dataSource={() => {
                    return props.cities;
                  }}
                  defaultSelected={searchForm.getField("city")}
                  onChange={(value: any) => {
                    searchForm.setField("city", value);
                    searchForm.setField("state", "");
                    // searchForm.setField("filter_by", {
                    //   value: "dated",
                    //   label: "Scheduled",
                    // });
                  }}
                  valueKey="value"
                  placeholder="City"
                /> */}
                <CustomSearchDropdown
                  onValueChange={(value: any) => {
                    searchForm.setField("city", value);
                    searchForm.setField("state", "");
                  }}
                  placeholderText="City"
                  defaultSelected={searchForm.getField("city")}
                  dataSource={() => {
                    return props.cities;
                  }}
                  styles={{
                    placeholderClass: "pr-1 overflow-hidden",
                    labelClass: "text-black",
                    optionItemClass: "border-b py-2",
                    showAllOptionAtTop: true,
                    allOptionsObject: { label: "All Cities", value: "" },
                  }}
                />
              </div>
            }
            suffix={
              <div className="pr-[11px] lg:pr-1.5">
                <Button
                  className="bg-brand-bgBlack h-9 w-9 p-2.5 rounded-full lg:px-4 lg:py-2 lg:rounded-md lg:text-white lg:h-[52px] lg:w-[112px]"
                  onClick={handleSubmit}
                >
                  <span className="hidden lg:flex">Search</span>
                  <div className="lg:hidden">
                    <SearchIcon className="w-5 h-5 text-white" />
                  </div>
                </Button>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}
